// Environment configuration
const isProd = process.env.NODE_ENV === 'production' || process.env.VERCEL_ENV === 'production';

const defaultProdApiUrl = 'https://bbw-backend-234257766766.europe-west1.run.app';
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL != null && process.env.VUE_APP_API_BASE_URL !== ''
  ? process.env.VUE_APP_API_BASE_URL
  : (isProd ? defaultProdApiUrl : 'http://localhost:5000');

export const config = {
  API_BASE_URL: apiBaseUrl,
  environment: isProd ? 'production' : 'development'
};
